import { Card, CardContent } from "@/components/ui/card";
import { FileText } from "lucide-react";

/**
 * Empty-state card shown when no data has been uploaded yet.
 */
export default function GettingStartedCard() {
  return (
    <Card className="border border-slate-200 shadow-none" data-testid="getting-started-card">
      <CardContent className="p-8 text-center">
        <div className="max-w-md mx-auto">
          <div className="w-16 h-16 bg-slate-100 rounded-sm flex items-center justify-center mx-auto mb-4">
            <FileText className="w-8 h-8 text-slate-400" />
          </div>
          <h3 className="text-lg font-semibold text-slate-900 mb-2">Get Started</h3>
          <p className="text-sm text-slate-500 mb-4">
            Upload your Tally XML files to generate financial reports. Start with COA,
            Trial Balance, and Daybook files.
          </p>
          <div className="text-xs text-slate-400">
            <p>Supported files:</p>
            <ul className="mt-2 space-y-1">
              <li>• Chart of Accounts (COA.xml)</li>
              <li>• Trial Balance (TrialBal.xml)</li>
              <li>• Daybook/Vouchers (Sales.xml, etc.)</li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
